import React from 'react'
import Hero from "../images/hero.png"
import Brand1 from "../images/brand/brand (1).png"
import Brand2 from "../images/brand/brand (2).png"
import Brand3 from "../images/brand/brand (3).png"
import Brand4 from "../images/brand/brand (4).png"
const HomeContainer = () => {
  return (
    
<section id='home' class="relative bg-white py-16 lg:pt-[100px]">
    <div class="mx-auto max-w-7xl px-8 md:px-6">
        <div class="flex flex-wrap">
            <div class="w-full lg:w-5/12">
                <h1 class="text-slate-800 mb-3 text-4xl font-bold leading-snug sm:text-[42px] lg:text-[40px] xl:text-[42px]">Everything you need to run your online <span class="text-blue-600">business</span></h1>
                <p class="text-slate-500 mb-8 max-w-[480px] text-base">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere alias voluptate esse blanditiis molestiae repudiandae fugiat eius sapiente expedita ut.
                </p>
                
                <button class="w-full rounded-md bg-blue-500 px-8 py-2.5 font-semibold text-white shadow-md shadow-blue-500/20 hover:bg-blue-600 duration-200 sm:w-auto">Get Started</button>

                <button class="mt-4 box-border w-full rounded-md border border-blue-500/20 px-8 py-2.5 font-semibold text-blue-500 shadow-md shadow-blue-500/10 duration-200 sm:ml-4 sm:mt-0 sm:w-auto ">Register Now</button>

                {/* <!-- brand --> */}
                <div class="mt-6 flex flex-wrap gap-4">
                    <img src={Brand1} alt="brand" class="w-32 cursor-pointer rounded-lg border border-blue-300/20 bg-white px-5 py-3 shadow-md shadow-blue-500/5 duration-200 hover:scale-95 sm:w-36" />
                    <img src={Brand2} alt="brand" class="w-32 cursor-pointer rounded-lg border border-blue-300/20 bg-white px-5 py-3 shadow-md shadow-blue-500/5 duration-200 hover:scale-95 sm:w-36" />
                    <img src={Brand3} alt="brand" class="w-32 cursor-pointer rounded-lg border border-blue-300/20 bg-white px-5 py-3 shadow-md shadow-blue-500/5 duration-200 hover:scale-95 sm:w-36" />
                    <img src={Brand4} alt="brand" class="w-32 cursor-pointer rounded-lg border border-blue-300/20 bg-white px-5 py-3 shadow-md shadow-blue-500/5 duration-200 hover:scale-95 sm:w-36" />
                </div>
            </div>

            <div class="hidden px-4 lg:block lg:w-1/12"></div>

            <div class="w-full px-4 lg:w-6/12">
                <div class="lg:ml-auto lg:text-right">
                    <div class="relative z-10 inline-block pt-11 lg:pt-0">
                        <img src={Hero} alt="hero section img" class="max-w-full lg:ml-auto" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default HomeContainer